'use strict';

window.slidePositionVieved = window.slidePositionVieved || {};
window.statElementCollector = window.statElementCollector || {};

for (const acc of document.querySelectorAll('.gallery__accordion')) {
	const wrapper = acc.closest('.__js_stats_wrapper');
	const artID = wrapper ? wrapper.dataset.id : undefined;
	const ga360id = acc.dataset.ga360Id;

	if (!ga360id) {
		console.log(
			'%c dodać ga360-id do Akordeonu: ' + (acc.dataset.id || ''),
			'background: #553311; padding: 3px; color: #ffaaaa'
		);
		continue;
	}

	statElementCollector[ga360id + '-' + artID] = {
		id: ga360id,
		moduleName: acc.dataset.id,
		viewedCount: 0,
		itemCount: acc.querySelectorAll('.accordion__element').length
	};

	slidePositionVieved[ga360id + '-' + artID] = {};
}

(function () {
	const elements = document.querySelectorAll('.accordion__element');
	for (const el of elements) {
		el.addEventListener('click', function () {
			if (window.isScrolling) return;

			if (!el.classList.contains('__jsActive')) {
				const accordion = el.closest('.gallery__accordion');
				if (!accordion) return;

				accordion.querySelectorAll('.accordion__element').forEach(n => n.classList.remove('__jsActive'));
				el.classList.add('__jsActive');

				const wrapper = el.closest('.__js_stats_wrapper');
				const artID = wrapper ? wrapper.dataset.id : undefined;
				const accID = el.parentElement ? el.parentElement.dataset.id : undefined;
				const elId = el.dataset.id;
				const imgID = el.querySelector('img') ? el.querySelector('img').dataset.src : undefined;
				const ga360id = accordion.dataset.ga360Id;
				const key = ga360id + '-' + artID;

				if (!slidePositionVieved[key]) slidePositionVieved[key] = {};

				let activeItem = -1;
				const siblings = el.parentNode ? el.parentNode.children : [];
				for (let i = 0; i < siblings.length; i++) {
					if (siblings[i] === el) { activeItem = i; break; }
				}

				if (activeItem > -1) {
					slidePositionVieved[key][activeItem] = 1;
					if (statElementCollector[key]) {
						statElementCollector[key].viewedCount = Object.keys(slidePositionVieved[key]).length;
					}
				}

				if (!window.isScrolligFlag) {
					if (window.WP && WP.push) {

						window.dataLayer.push({
							event: 'content_interaction',
							eventCategory: ga360id,
							moduleName: accID,
							eventAction: window.deviceTouch ? 'tap' : 'click',
							eventLabel: activeItem + 1
						});

					}

					if (typeof sendStats === 'function') {
						sendStats('gallery-accordion', 'hover-' + elId, artID + ' / ' + accID, imgID);
					}
				}
			}
		});
	}
})();